<template>
  <v-container>
    <v-flex class="flex">
      <v-layout>
        <v-card class="masterCard">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            ref="table"
            :headers="headers"
            :items="Auxiliares"
            :items-per-page="5"
            :rows-per-page="20"
            :page="1"
            :loading="loading"
            :search="search"
            @click:row="editDialog"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Auxiliares {{ auxType }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="AuxDialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#015CAB"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      >Agregar Auxiliar</v-btn
                    >
                  </template>

                  <v-card>
                    <v-progress-circular
                      indeterminate
                      class="loading"
                      color="primary"
                      v-if="loading"
                    >
                      Cargando
                    </v-progress-circular>
                    <v-card-text v-else>
                      <v-row>
                        <v-col cols="12" sm="20" md="20">
                          <v-text-field
                            v-model="editedItem.name"
                            label="Nombre del auxiliar"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="20" md="20">
                          <v-autocomplete
                            label="Pregunta a vincular"
                            v-model="editedItem.type"
                            :items="questionsList"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="40" md="40">
                          <v-text-field
                            v-model="editedItem.value"
                            label="Valor del auxiliar"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="40" md="40">
                          <v-text-field
                            v-model="editedItem.dependency"
                            label="Dependencia del auxiliar"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#015CAB" text @click="save">Guardar</v-btn>
                      <v-btn color="#E1251B" text @click="close"
                        >Cancelar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.controls="{ item }">
              <!-- stop prop prevent to trigget the click row event -->
              <v-icon small class="mr-2" @click.stop="remove(item.id)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import {
  addAuxiliar,
  editAuxiliar,
  removeAuxiliar,
  getQuestions,
} from "@/utils/apiRequest";
export default {
  data() {
    return {
      AuxDialog: false,
      edited: false,
      search: "",
      questions: [],
      questionsList: [],
      loading: true,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Nombre", value: "name" },
        { text: "Valor", value: "value" },
        { text: "Tipo", value: "type" },
        { text: "Dependencia", value: "dependency" },
        { text: "", value: "controls" },
      ],
      editedItem: {
        id: "",
        name: "",
        value: "",
        type: "",
        dependency: "",
      },
      defaultItem: {
        id: "",
        name: "",
        value: "",
        type: "",
        dependency: "",
      },
    };
  },
  props: {
    Auxiliares: Array,
    auxType: String,
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    close() {
      this.AuxDialog = false;
      this.edited = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (!this.edited) {
        let Aux = {
          name: this.editedItem.name,
          value: this.editedItem.value,
          type: this.editedItem.type,
          dependency: this.editedItem.dependency,
        };
        let updatedAux = await addAuxiliar(Aux);
        if (updatedAux.data.status == "success") {
          window.location.reload();
          this.close();
        }
      } else {
        let Aux = {
          id: this.editedItem.id,
          name: this.editedItem.name,
          value: this.editedItem.value,
          type: this.editedItem.type,
          dependency: this.editedItem.dependency,
        };
        let updatedAux = await editAuxiliar(this.editedItem.id, Aux);
        if (updatedAux.data.status == "success") {
          this.edited = false;
          window.location.reload();
          this.close();
        }
      }
    },
    async remove(id) {
      let updatedAux = await removeAuxiliar(id);
      if (updatedAux.data.status == "success") {
        this.edited = false;
        this.Auxiliares = this.Auxiliares.filter(aux => aux.id != id);
        this.close();
      }
    },
    editDialog(item) {
      this.edited = true;
      this.editedItem = Object.assign({}, item);
      this.AuxDialog = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  async mounted() {
    let response = await getQuestions();
    if (response.data.status == "success") {
      this.questions = response.data.sections;
      response.data.sections.forEach((sections) => {
        sections.questions.forEach((question) => {
          this.questionsList.push(question.question);
        });
      });
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.masterCard {
  align-self: center;
  margin: 0 auto;
}

.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}


</style>